module.exports = __webpack_public_path__ + "img/user-profile.e7892b70.png";